/**
 * @generated SignedSource<<13eca6c9ec15af8625bf55b3fb6dc985>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type hooksTopStoriesTrackingQueueItemsEdge$data = ReadonlyArray<{
  readonly node: {
    readonly entityId?: string;
    readonly urlAlias?: string;
  };
  readonly " $fragmentType": "hooksTopStoriesTrackingQueueItemsEdge";
}>;
export type hooksTopStoriesTrackingQueueItemsEdge$key = ReadonlyArray<{
  readonly " $data"?: hooksTopStoriesTrackingQueueItemsEdge$data;
  readonly " $fragmentSpreads": FragmentRefs<"hooksTopStoriesTrackingQueueItemsEdge">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "hooksTopStoriesTrackingQueueItemsEdge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "entityId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "urlAlias",
              "storageKey": null
            }
          ],
          "type": "Content",
          "abstractKey": "__isContent"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "QueueItemsEdge",
  "abstractKey": null
};

(node as any).hash = "099157b6b475aef12841633ffde4dd0d";

export default node;
